import gql from 'graphql-tag';

import lessonFragment from '~/shared/graphql-queries/lessons/lesson-fragment';

export default gql`
  query findByAliasesLessonQuery(
    $alias: String!
    $courseCategoryAlias: String!
    $lessonAlias: String!
    $lessonTemplate: String
  ) {
    findByAliasesLessonQuery(
      alias: $alias
      courseCategoryAlias: $courseCategoryAlias
      lessonAlias: $lessonAlias
      lessonTemplate: $lessonTemplate
    ) {
      ...LessonFragment
    }
  }
  ${lessonFragment}
`;
